// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__x_ePz","range":"MonthRangeSwitch_range__3ARwa","disabled":"MonthRangeSwitch_disabled__pG9cl"};